import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";

const features = [
    {
        title: "User Management",
        description: "Manage customer data, track interactions, and segment leads effectively.",
        imgUrl: "./img/services/cms-solutions/user-management.png",
    },
    {
        title: "Sales Tracking",
        description: "Monitor sales activities, forecast revenue, and improve sales processes.",
        imgUrl: "./img/services/cms-solutions/sales-tracking.png",
    },
    {
        title: "Marketing Automation",
        description: "Automate email marketing campaigns and track customer engagement.",
        imgUrl: "./img/services/cms-solutions/marketing-automation.jpg",
    },
    {
        title: "Customer Insights",
        description: "Gain insights into customer behavior, preferences, and buying patterns.",
        imgUrl: "./img/services/cms-solutions/customer-insights.jpg",
    },
    {
        title: "Integration with Other Tools",
        description: "Connect CRM with other tools like email, analytics, and eCommerce platforms.",
        imgUrl: "./img/services/cms-solutions/integration-with-other-tools.jpg",
    },
    {
        title: "Customer Support",
        description: "Provide better customer service with automated ticketing and chat features.",
        imgUrl: "./img/services/cms-solutions/customer-support.jpg",
    },
];

const CRM_Solutions = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "CRM Solutions", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="CRM Solutions" description="Streamline your customer relationships with robust CRM solutions designed to boost sales, improve customer engagement, and enhance productivity." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is a CRM?</h2>
                            <p>
                                Customer Relationship Management (CRM) is a system designed to manage a company's interactions with current and potential customers. It helps businesses keep track of customer data, sales, and marketing efforts to improve overall business efficiency and customer satisfaction.
                            </p>
                            <img
                                src="./img/services/cms-solutions.jpg"
                                alt="CRM Solutions"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key CRM Features</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Popular CRM Platforms</h2>
                            <ul>
                                <li>
                                    <strong>Salesforce:</strong> A leading CRM for enterprise-level businesses with features like analytics, automation, and customization.
                                </li>
                                <li>
                                    <strong>HubSpot:</strong> A user-friendly CRM with tools for sales, marketing, and customer service, ideal for small to medium-sized businesses.
                                </li>
                                <li>
                                    <strong>Zoho CRM:</strong> An affordable CRM offering features like sales tracking, email marketing, and automation.
                                </li>
                                <li>
                                    <strong>Microsoft Dynamics 365:</strong> An integrated CRM and ERP solution, perfect for large-scale businesses with complex needs.
                                </li>
                                <li>
                                    <strong>PipeDrive:</strong> Known for its sales pipeline management, ideal for small to medium-sized businesses.
                                </li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Enhance Your Customer Relationships with Our CRM Solutions</h2>
                            <p>
                                Discover the best CRM solution tailored to your business needs. <br />
                                Get in touch with us at{" "}
                                <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default CRM_Solutions;
